import { useEffect, useState } from 'react'
import Renderer from '../classes/renderer'

export function useTexture(renderer: Renderer | null, source?: TexImageSource | null) {
    const [state, setState] = useState<WebGLTexture | null>(null)

    useEffect(() => {
        if (!renderer || !source) return

        setState(renderer.createTexture(source))
    }, [renderer, source])

    return state
}
